import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#4a0089',
      // dark: will be calculated from palette.primary.main,
      contrastText: '#fafafa',
    },
    secondary: {
      main: '#FF2667',
      contrastText: '#fafafa',
    },
    error: {
      main: '#F35A5A',
      contrastText: '#fafafa',
    },
  },
  typography: {
    fontFamily: [
      'Muli',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});

export default responsiveFontSizes(theme);
